import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { List } from 'semantic-ui-react';

import { InsightsState } from 'app-redux/InsightsState';

import { Error } from 'components/Error';

import { fetchLocations } from 'locations/locations.saga';
import locationsSelectors from 'locations/locations.selectors';

import GlobalLocationCard from './GlobalLocationCard';
import LocationCard from './LocationCard';

export const LocationsList: React.FC = () => {
  const dispatch = useDispatch();
  const allLocationIds = useSelector<InsightsState, number[]>(locationsSelectors.getAllLocationIds);
  const hasError = useSelector<InsightsState, boolean>(locationsSelectors.hasError);

  return (
    <List>
      {hasError ? (
        <Error
          title="Something went wrong."
          subtitle="Please check your network connectivity and try again."
          linkText="Click here to retry"
          linkCallback={() => dispatch(fetchLocations())}
        />
      ) : (
        <>
          <GlobalLocationCard />
          {allLocationIds.map(id => (
            <LocationCard key={id} geonameId={id} />
          ))}
        </>
      )}
    </List>
  );
};

export default LocationsList;
